import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/API";

export const postLocation = createAsyncThunk("postLocation", async (data) => {
    const response = await axiosInstance.post(`/location/update-session/`, data);
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

export const searchLocation = createAsyncThunk("searchLocation", async (query) => {
    try {
        const response = await axiosInstance.post(`/search-and-save-location/`, { query });
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const getSessionLocation = createAsyncThunk("getSessionLocation", async (_, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get(`/location/get-session/`);
        return response.data;
    } catch (error) {
        return rejectWithValue(error?.response?.data || error.message);
    }
});

export const LocationSlice = createSlice({
    name: "Location",
    initialState: {
        loading: false,
        sessionLoading: false,
        error: null,
        location: {},
        sessionLocation: null,
        permissionType: null,
    },
    extraReducers: (builder) => {
        builder.addCase(postLocation.pending, (state) => {
            state.loading = true;
            state.location = {};
        });
        builder.addCase(postLocation.fulfilled, (state, action) => {
            state.loading = false;
            state.location = action.payload;
        });
        builder.addCase(postLocation.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        builder.addCase(getSessionLocation.pending, (state) => {
            state.sessionLoading = true;
        });
        builder.addCase(getSessionLocation.fulfilled, (state, action) => {
            state.sessionLoading = false;
            const data = action.payload?.data || action.payload;
            state.sessionLocation = data;
            state.permissionType = data?.permission_type ?? null;
        });
        builder.addCase(getSessionLocation.rejected, (state, action) => {
            state.sessionLoading = false;
            state.error = action.payload;
        });
    },
});

export default LocationSlice.reducer;